import { TCommonTaskProp } from '../../../types';
import MarkAsCompleteTask from '../MarkAsCompleteTask';

export const WorkflowDefaultTask = ({
  task,
  context,
  isTimelineView,
  displayNumber,
}: TCommonTaskProp) => {
  const { workflowExecution } = context;
  if (!workflowExecution?.WorkflowTemplateVersion?.definition)
    console.error('Workflow definition not found');
  if (!workflowExecution?.runtime?.stepExecutions)
    console.error('Workflow runtime step executions not found');

  return (
    <div className="flex flex-row gap-2">
      <MarkAsCompleteTask
        task={task}
        context={context}
        isTimelineView={isTimelineView}
        displayNumber={displayNumber}
      />
    </div>
  );
};
